import { render } from "./BirdSelect.vue?vue&type=template&id=274143fa&scoped=true"
import script from "./BirdSelect.vue?vue&type=script&lang=js"
export * from "./BirdSelect.vue?vue&type=script&lang=js"

import "./BirdSelect.vue?vue&type=style&index=0&id=274143fa&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/Danmarksfugle2.0-frontend/code-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274143fa"]])

export default __exports__